
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta } from "/app/pages/register.vue?macro=true";
import { default as indexRwX3HD4m7UgCTflfWJ6Hh6cMY30IppECl837rIfE05QMeta } from "/app/pages/base/index.vue?macro=true";
import { default as _403D5wPMeYtuztF0zK6cisuFylQCPtJFD9x8rc93K0gT3EMeta } from "/app/pages/base/error/403.vue?macro=true";
import { default as editorsUt67851vJYKbRWiOFtKUEeGUhGTxoEtyi5zhb7NHY4kMeta } from "/app/pages/base/demo/editors.vue?macro=true";
import { default as editorsVfylVROkLOcQuaumkuRICj2zsWIYnwG7OSTF4OmdWZkMeta } from "/app/pages/base/guide/editors.vue?macro=true";
import { default as index9_Yktad4IfQQsnXl4DtL6px8sl18NBkcOwqsdbEP7HoMeta } from "/app/pages/base/my-info/index.vue?macro=true";
import { default as indexqrcJta_45fbY3oXmXmjKkyXa_uChIib9pPY6dnznp8A0MMeta } from "/app/pages/biz/site/faq/index.vue?macro=true";
import { default as password_45resetATJ8ZVSzp7f_8LiLOoeMAdhVO8CXTJ_45LyT6LiDSHJHMMeta } from "/app/pages/auth/password-reset.vue?macro=true";
import { default as indexfrQOtT9z4JqZu0Ko2hc8I7fZ3ZHexjOFDCY8ZWcGapMMeta } from "/app/pages/biz/ksis/main/index.vue?macro=true";
import { default as _91id_934qqO9ZD9GnfP3KQfvU1kX5fE9YzC4dduniKraT2jx90Meta } from "/app/pages/base/demo/board/[id].vue?macro=true";
import { default as index9v403xsFOOurkc3HP4eflM6Xo5l_45hkzInVK3NUOkk88Meta } from "/app/pages/base/demo/board/index.vue?macro=true";
import { default as writeJyWzznIXeW9YJQuqTvhaHDdfKbbZk5D_riV7pZMh__45AMeta } from "/app/pages/base/demo/board/write.vue?macro=true";
import { default as file_45uploadnaZnIdPXUUkoWjfSFLKySJFshzMLUBa1AGV1lDZCr6UMeta } from "/app/pages/base/demo/file-upload.vue?macro=true";
import { default as i18n_45scrolllmKtA_dBY4K0HFhzKqIMIXTzAjssOvs5d4oKmNY20AwMeta } from "/app/pages/base/demo/i18n-scroll.vue?macro=true";
import { default as componentsplajV7WaS9aM81QMIFOh55X8f2fwzeNAXHdE7ZAYl64Meta } from "/app/pages/base/guide/components.vue?macro=true";
import { default as indexXxL4BqeB8LnXmYo5DTcj8Vh5sikPN0XrLfWqWqizUsYMeta } from "/app/pages/biz/ksis/dev/eo/index.vue?macro=true";
import { default as indexa7jL_67TjonHZgpYals4Nhcf8GG_45XMF2pmVS96k5TCYMeta } from "/app/pages/biz/site/notice/index.vue?macro=true";
import { default as board_45pagingqMgFSgBZrJuNFC0dPNcYnLtyIZQKLeFhpLWyeQSJyKcMeta } from "/app/pages/base/demo/board-paging.vue?macro=true";
import { default as board_45scrollcJrL6gLK2gfkt__qQYs6AUqc8xemkBR1wmIjyskCuYwMeta } from "/app/pages/base/demo/board-scroll.vue?macro=true";
import { default as index34CTscCwatbGGCeL4ttmdZwLnTUvD10V9m12TcrGS1MMeta } from "/app/pages/biz/ksis/etc/todo/index.vue?macro=true";
import { default as indexF5YH7eid_ZQs_45u8mSIaDLGOSdZoHfZWuRXDefBe_45IuoMeta } from "/app/pages/biz/ksis/order/rfq/index.vue?macro=true";
import { default as index7FtO5yx_45N0mJ47747vsfA6oZVYd6cC9AuSrrKIuUCv4Meta } from "/app/pages/base/demo/breakdown/index.vue?macro=true";
import { default as indexA10nicgn6dEO3W_zNnq18zkoU0gf6viBKH110gdNfWMMeta } from "/app/pages/base/message/msglog/index.vue?macro=true";
import { default as indexUuSgnby7kXBoWFRY3dLG_45uIDrcqogRKxTSSI8NBrb4MMeta } from "/app/pages/base/demo/excel-grid/index.vue?macro=true";
import { default as indexngJKK4goSjo1LBjpbmQaVApE1vNHIrDVx6NpEroYk_45sMeta } from "/app/pages/base/system/auth/log/index.vue?macro=true";
import { default as indexcarL4xs354pJLe42aigb9NCPz2mctPksANmu_45xWF6moMeta } from "/app/pages/biz/ksis/dev/pending/index.vue?macro=true";
import { default as index_45YS43T45BFTD1NQnrmSFpPGPHPmt3OTHaPyuiq_FfckMeta } from "/app/pages/base/demo/excel-chart/index.vue?macro=true";
import { default as indexZO0sw_451rVJ_45mWuUx3JmxUeZdyyb0w_455OKt2PSh9J8hYMeta } from "/app/pages/base/message/template/index.vue?macro=true";
import { default as index9NemycVmkEXp3_vCl_gbvFnYwvEQd9GHg1_45YzZkk7aIMeta } from "/app/pages/biz/ksis/dev/dev-cost/index.vue?macro=true";
import { default as testJnGo8yXCm6FnW_BR4qWaOirbNNSk46DAnqugRR_45RXoAMeta } from "/app/pages/base/demo/notifications/test.vue?macro=true";
import { default as indexxeUQJb3THBK2qbylFajYng5i4oetxputGS6QEtDPLmoMeta } from "/app/pages/base/system/auth/roles/index.vue?macro=true";
import { default as indexhSuDUY6B2LeLZKEXuyBWPTLnEBKicn9g5eRjkGJNra0Meta } from "/app/pages/base/system/auth/users/index.vue?macro=true";
import { default as board_45scroll_45sample2kpNiwCOo1QkzrnOM15FZToyIMLrD3sER7RkwhNXgOYMeta } from "/app/pages/base/demo/board-scroll-sample.vue?macro=true";
import { default as sort_45board_JknHbgp3a23CP0e1t2PFe7IZoCBhdZ0VzqDZp8dcJcMeta } from "/app/pages/base/guide/backend/sort-board.vue?macro=true";
import { default as indexGBHeGeTCakJrkZZDBMzr16QceYYNvmFVAvSwK7yId60Meta } from "/app/pages/base/system/tools/batch/index.vue?macro=true";
import { default as indexPkZyqFSyGAAac4Byz_iBXZgrzu_45CLkXAleH63FDgT0IMeta } from "/app/pages/biz/ksis/dev/unit-price/index.vue?macro=true";
import { default as indexfmLv8vqRTNMAL3cctmu63nxHK4cvHmmvgP0Kt3xMa4kMeta } from "/app/pages/biz/ksis/longterm/sales/index.vue?macro=true";
import { default as indexOjaST7dL9spZv7IrWoWZXC_tNibXJNZ8B4DtaAoReVYMeta } from "/app/pages/biz/ksis/price/overseas/index.vue?macro=true";
import { default as indexRKTuw4yddSsWyz_k_aFHxmNruFVlXboRH2c24lXN1T4Meta } from "/app/pages/biz/ksis/price/sub-item/index.vue?macro=true";
import { default as indexjIXzN76ZxApQJHZv4SCIlO_45q6kYPuwTB_45ZNHDR9kFrAMeta } from "/app/pages/biz/ksis/order/quote-doc/index.vue?macro=true";
import { default as index1UoUacukDpWSRxGRSgFCi9r6sd2mWq62TvCKlRwzkZYMeta } from "/app/pages/biz/ksis/price/mold-cost/index.vue?macro=true";
import { default as api_45executor989x2QMRVkQC17qj_i242VWpjYmT_45CpKDphW7qCojpAMeta } from "/app/pages/base/guide/backend/api-executor.vue?macro=true";
import { default as paging_45boardw0UDuPGvLqhs0taaQpRWScwlYndBG6anwiMd6K0WK8oMeta } from "/app/pages/base/guide/backend/paging-board.vue?macro=true";
import { default as scroll_45boardgpEplvauv3iJXMN7gcxw7biSuS3tSIahrriojTAR_4550Meta } from "/app/pages/base/guide/backend/scroll-board.vue?macro=true";
import { default as indexqbgYiy7iR8cwyL5hdvxoLmka_n3xAZoeCetuVEv4HEQMeta } from "/app/pages/base/system/settings/i18n/index.vue?macro=true";
import { default as indexPZ_45uOgDmYToL7maluZCfXnEgVaBzrW_45Ux2CB0lgLIzkMeta } from "/app/pages/biz/ksis/dev/mold-process/index.vue?macro=true";
import { default as indexvoFd_45d0dWyiBNDHCP_NCVufBJCqRXielr4qnr364NDMMeta } from "/app/pages/biz/ksis/etc/tech-service/index.vue?macro=true";
import { default as indexXyvuFbScy7b_6jbixM2DToB9D_45es3jEJCFSHj2kOU64Meta } from "/app/pages/biz/ksis/order/order-info/index.vue?macro=true";
import { default as biz_45dev_45guideuOGfI4kgzjJOcBPNq95AxQQAnLgkwq2t9AEaBFoar_458Meta } from "/app/pages/base/guide/backend/biz-dev-guide.vue?macro=true";
import { default as indexT4NGwpn25IwEDM2y9me8aWaR6itAIV9NfRmhcdoIo_45QMeta } from "/app/pages/base/system/settings/codes/index.vue?macro=true";
import { default as index_Kn87_45zTz8V1MaRjxLLcdlUcdRz3E5itK5Db83tsF04Meta } from "/app/pages/base/system/settings/menus/index.vue?macro=true";
import { default as indexoEY4MRAkW9SNRxCk_BJ9h6DDJsfVLkLFrS3f7HV_CDwMeta } from "/app/pages/biz/ksis/baseinfo/customer/index.vue?macro=true";
import { default as indexGg6s3g3H3_45npG6W5uliPxTRo13QfIqFPcd1P_FDpTwYMeta } from "/app/pages/biz/ksis/order/quote-draft/index.vue?macro=true";
import { default as indexCmvGxq7OwpbRrjB_3Fn733SFcZB1Pc9k8jVgVxK2Ou4Meta } from "/app/pages/biz/ksis/price/design-cost/index.vue?macro=true";
import { default as indexbuvHT7ZWBaeeII82S6ZbwBrg6gUK8e4EDxKvTNoB6rYMeta } from "/app/pages/biz/ksis/price/negotiation/index.vue?macro=true";
import { default as indexif85_45L7eGxLvCVZC2i6YnMMXgDiCV_451yB_5I4zIk_45kgMeta } from "/app/pages/base/system/tools/generator/index.vue?macro=true";
import { default as indexOkiQE7tYRFWiIsFGuENCGldYnLVGWWRT3FcOVZqOanoMeta } from "/app/pages/biz/ksis/approval/authority/index.vue?macro=true";
import { default as indexy5VvXRKNLKRS6ViYXChNXN2AZSNIZmO1T32OQI0N5_8Meta } from "/app/pages/biz/ksis/order/order-result/index.vue?macro=true";
import { default as indexk4tgk9m14loTOytxl5spCXrKEksxe1wG11EYnBK3msEMeta } from "/app/pages/biz/ksis/pdis/product-order/index.vue?macro=true";
import { default as indexz5OXN6_LVYu0nNirhl1pCb9HoxUB1T5oeBlnqMRoLJUMeta } from "/app/pages/biz/ksis/price/inspect-diff/index.vue?macro=true";
import { default as infinite_45scrollEmAoCwdGEI9VdORn7HUN_oJZaq7O6zyx19OrBB_45WamsMeta } from "/app/pages/base/guide/backend/infinite-scroll.vue?macro=true";
import { default as sending_45serviceZTnircmNTJkwdZkQUi5MjCzvjljjAs0IhFtoCyPu0ogMeta } from "/app/pages/base/guide/backend/sending-service.vue?macro=true";
import { default as indexy5oNqBhlS0TZn4O9_VbbbMfxQZLpGynKlRL1BJRV_45_45YMeta } from "/app/pages/base/system/dashboard/layout/index.vue?macro=true";
import { default as indextPeN2BFDUUv0KE7bFOKGcfmLZG4WsMRLcxSwWebkPFUMeta } from "/app/pages/biz/ksis/approval/delegation/index.vue?macro=true";
import { default as index88ZJz_phaJA82GCBNn7Dh6DlS6BG2IkRgK0_45VZPyj9sMeta } from "/app/pages/biz/ksis/baseinfo/change-log/index.vue?macro=true";
import { default as indexgmbGMdTKZqxy_45I5IvY7ufSHfWmk7c5eZGDGspZP9DPgMeta } from "/app/pages/biz/ksis/baseinfo/hmc-prefix/index.vue?macro=true";
import { default as indexwYPLnoRwmmvX3GXlsg2slD0vDnYKKBTMwvcM95twpcsMeta } from "/app/pages/biz/ksis/baseinfo/item-group/index.vue?macro=true";
import { default as indexY4KgfPmgt2U8OE_WemRN_45NECKLHOYh9NiDsCovvp4ZwMeta } from "/app/pages/biz/ksis/order/status-by-doc/index.vue?macro=true";
import { default as dashboard_45widgetrBqnehBB5W_XOE5yBOzrcu0qvs2dUBpGbbmpCwi6PZkMeta } from "/app/pages/base/guide/backend/dashboard-widget.vue?macro=true";
import { default as indexembP40VS22dsxUf_Z1NfXvMkRzWG2XXnpzhU7RC53FgMeta } from "/app/pages/biz/ksis/baseinfo/bid-project/index.vue?macro=true";
import { default as widget_45managerRUMfUb1C4i9nYk_VfJVSq_45_lFTKR35phpIeiveIBS1AMeta } from "/app/pages/base/system/dashboard/widget-manager.vue?macro=true";
import { default as indexxeYtRJwdzFhbMS6PKZqXQjt7CPyw_45sKx4AocEWqIdmoMeta } from "/app/pages/biz/ksis/price/part-comparison/index.vue?macro=true";
import { default as index3zVUMKY883tV5fsmVojrc_JN_i4WEfRa2y8EaVPoVfQMeta } from "/app/pages/biz/ksis/baseinfo/spec-category/index.vue?macro=true";
import { default as index6FgeHQ9DUV4mfLeJAyHeDg2o6SoNPcfF6UjiJyEXGvQMeta } from "/app/pages/biz/ksis/price/agreed-reduction/index.vue?macro=true";
import { default as indexu2ZSDKtihEF_45K61Ce4BdrMuyIB0cvxRP3EpXSDoVoRoMeta } from "/app/pages/biz/ksis/workbase/business-trip/index.vue?macro=true";
import { default as indexh9D949mmfhFwcQngidDxzbv4daFyFgdTwtlDgJUUShcMeta } from "/app/pages/biz/ksis/order/status-by-project/index.vue?macro=true";
import { default as indexrCjY5VMub9k6pJD8r1Kivh3cF3X6Y3mHpdvYMANfoL8Meta } from "/app/pages/base/system/auth/menu-permissions/index.vue?macro=true";
import { default as indexp3aGhpRZGcePQ9UmhXYhXvlgc5lrPvbs0OFgpTeGVugMeta } from "/app/pages/biz/ksis/baseinfo/item-group-owner/index.vue?macro=true";
import { default as indexd55aXi8bGNYcDns_b4c6MndZsKoW3gUc3xoqQTOA3DAMeta } from "/app/pages/biz/ksis/price/overseas-status-all/index.vue?macro=true";
import { default as indexhSDMzPLmwnAA5E5Z2MO7FS4kJBheKSWCoL3vFQmwLR4Meta } from "/app/pages/biz/ksis/baseinfo/customer-part-map/index.vue?macro=true";
import { default as indexSf0r_ASwCdl_45OYUkATPLs7h_45mRzmBhLsoThqXM9cDa0Meta } from "/app/pages/biz/ksis/workbase/official-document/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: {"middleware":"auth"},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta || {},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerhhTixNN_gvg3OZSt2Nh0apJnSWfEASm8HSODFR1YEGYMeta || {},
    component: () => import("/app/pages/register.vue")
  },
  {
    name: "base",
    path: "/base",
    meta: { ...(indexRwX3HD4m7UgCTflfWJ6Hh6cMY30IppECl837rIfE05QMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/index.vue")
  },
  {
    name: "base-error-403",
    path: "/base/error/403",
    meta: _403D5wPMeYtuztF0zK6cisuFylQCPtJFD9x8rc93K0gT3EMeta || {},
    component: () => import("/app/pages/base/error/403.vue")
  },
  {
    name: "base-demo-editors",
    path: "/base/demo/editors",
    meta: { ...(editorsUt67851vJYKbRWiOFtKUEeGUhGTxoEtyi5zhb7NHY4kMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/demo/editors.vue")
  },
  {
    name: "base-guide-editors",
    path: "/base/guide/editors",
    meta: { ...(editorsVfylVROkLOcQuaumkuRICj2zsWIYnwG7OSTF4OmdWZkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/guide/editors.vue")
  },
  {
    name: "base-my-info",
    path: "/base/my-info",
    meta: { ...(index9_Yktad4IfQQsnXl4DtL6px8sl18NBkcOwqsdbEP7HoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/my-info/index.vue")
  },
  {
    name: "biz-site-faq",
    path: "/biz/site/faq",
    meta: { ...(indexqrcJta_45fbY3oXmXmjKkyXa_uChIib9pPY6dnznp8A0MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/site/faq/index.vue")
  },
  {
    name: "auth-password-reset",
    path: "/auth/password-reset",
    meta: password_45resetATJ8ZVSzp7f_8LiLOoeMAdhVO8CXTJ_45LyT6LiDSHJHMMeta || {},
    component: () => import("/app/pages/auth/password-reset.vue")
  },
  {
    name: "biz-ksis-main",
    path: "/biz/ksis/main",
    meta: { ...(indexfrQOtT9z4JqZu0Ko2hc8I7fZ3ZHexjOFDCY8ZWcGapMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/main/index.vue")
  },
  {
    name: "base-demo-board-id",
    path: "/base/demo/board/:id()",
    meta: { ...(_91id_934qqO9ZD9GnfP3KQfvU1kX5fE9YzC4dduniKraT2jx90Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/demo/board/[id].vue")
  },
  {
    name: "base-demo-board",
    path: "/base/demo/board",
    meta: { ...(index9v403xsFOOurkc3HP4eflM6Xo5l_45hkzInVK3NUOkk88Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/demo/board/index.vue")
  },
  {
    name: "base-demo-board-write",
    path: "/base/demo/board/write",
    meta: { ...(writeJyWzznIXeW9YJQuqTvhaHDdfKbbZk5D_riV7pZMh__45AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/demo/board/write.vue")
  },
  {
    name: "base-demo-file-upload",
    path: "/base/demo/file-upload",
    meta: { ...(file_45uploadnaZnIdPXUUkoWjfSFLKySJFshzMLUBa1AGV1lDZCr6UMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/demo/file-upload.vue")
  },
  {
    name: "base-demo-i18n-scroll",
    path: "/base/demo/i18n-scroll",
    meta: { ...(i18n_45scrolllmKtA_dBY4K0HFhzKqIMIXTzAjssOvs5d4oKmNY20AwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/demo/i18n-scroll.vue")
  },
  {
    name: "base-guide-components",
    path: "/base/guide/components",
    meta: { ...(componentsplajV7WaS9aM81QMIFOh55X8f2fwzeNAXHdE7ZAYl64Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/guide/components.vue")
  },
  {
    name: "biz-ksis-dev-eo",
    path: "/biz/ksis/dev/eo",
    meta: { ...(indexXxL4BqeB8LnXmYo5DTcj8Vh5sikPN0XrLfWqWqizUsYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/dev/eo/index.vue")
  },
  {
    name: "biz-site-notice",
    path: "/biz/site/notice",
    meta: { ...(indexa7jL_67TjonHZgpYals4Nhcf8GG_45XMF2pmVS96k5TCYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/site/notice/index.vue")
  },
  {
    name: "base-demo-board-paging",
    path: "/base/demo/board-paging",
    meta: { ...(board_45pagingqMgFSgBZrJuNFC0dPNcYnLtyIZQKLeFhpLWyeQSJyKcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/demo/board-paging.vue")
  },
  {
    name: "base-demo-board-scroll",
    path: "/base/demo/board-scroll",
    meta: { ...(board_45scrollcJrL6gLK2gfkt__qQYs6AUqc8xemkBR1wmIjyskCuYwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/demo/board-scroll.vue")
  },
  {
    name: "biz-ksis-etc-todo",
    path: "/biz/ksis/etc/todo",
    meta: { ...(index34CTscCwatbGGCeL4ttmdZwLnTUvD10V9m12TcrGS1MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/etc/todo/index.vue")
  },
  {
    name: "biz-ksis-order-rfq",
    path: "/biz/ksis/order/rfq",
    meta: { ...(indexF5YH7eid_ZQs_45u8mSIaDLGOSdZoHfZWuRXDefBe_45IuoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/order/rfq/index.vue")
  },
  {
    name: "base-demo-breakdown",
    path: "/base/demo/breakdown",
    meta: { ...(index7FtO5yx_45N0mJ47747vsfA6oZVYd6cC9AuSrrKIuUCv4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/demo/breakdown/index.vue")
  },
  {
    name: "base-message-msglog",
    path: "/base/message/msglog",
    meta: { ...(indexA10nicgn6dEO3W_zNnq18zkoU0gf6viBKH110gdNfWMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/message/msglog/index.vue")
  },
  {
    name: "base-demo-excel-grid",
    path: "/base/demo/excel-grid",
    meta: { ...(indexUuSgnby7kXBoWFRY3dLG_45uIDrcqogRKxTSSI8NBrb4MMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/demo/excel-grid/index.vue")
  },
  {
    name: "base-system-auth-log",
    path: "/base/system/auth/log",
    meta: { ...(indexngJKK4goSjo1LBjpbmQaVApE1vNHIrDVx6NpEroYk_45sMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/system/auth/log/index.vue")
  },
  {
    name: "biz-ksis-dev-pending",
    path: "/biz/ksis/dev/pending",
    meta: { ...(indexcarL4xs354pJLe42aigb9NCPz2mctPksANmu_45xWF6moMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/dev/pending/index.vue")
  },
  {
    name: "base-demo-excel-chart",
    path: "/base/demo/excel-chart",
    meta: { ...(index_45YS43T45BFTD1NQnrmSFpPGPHPmt3OTHaPyuiq_FfckMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/demo/excel-chart/index.vue")
  },
  {
    name: "base-message-template",
    path: "/base/message/template",
    meta: { ...(indexZO0sw_451rVJ_45mWuUx3JmxUeZdyyb0w_455OKt2PSh9J8hYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/message/template/index.vue")
  },
  {
    name: "biz-ksis-dev-dev-cost",
    path: "/biz/ksis/dev/dev-cost",
    meta: { ...(index9NemycVmkEXp3_vCl_gbvFnYwvEQd9GHg1_45YzZkk7aIMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/dev/dev-cost/index.vue")
  },
  {
    name: "base-demo-notifications-test",
    path: "/base/demo/notifications/test",
    meta: { ...(testJnGo8yXCm6FnW_BR4qWaOirbNNSk46DAnqugRR_45RXoAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/demo/notifications/test.vue")
  },
  {
    name: "base-system-auth-roles",
    path: "/base/system/auth/roles",
    meta: { ...(indexxeUQJb3THBK2qbylFajYng5i4oetxputGS6QEtDPLmoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/system/auth/roles/index.vue")
  },
  {
    name: "base-system-auth-users",
    path: "/base/system/auth/users",
    meta: { ...(indexhSuDUY6B2LeLZKEXuyBWPTLnEBKicn9g5eRjkGJNra0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/system/auth/users/index.vue")
  },
  {
    name: "base-demo-board-scroll-sample",
    path: "/base/demo/board-scroll-sample",
    meta: { ...(board_45scroll_45sample2kpNiwCOo1QkzrnOM15FZToyIMLrD3sER7RkwhNXgOYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/demo/board-scroll-sample.vue")
  },
  {
    name: "base-guide-backend-sort-board",
    path: "/base/guide/backend/sort-board",
    meta: { ...(sort_45board_JknHbgp3a23CP0e1t2PFe7IZoCBhdZ0VzqDZp8dcJcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/guide/backend/sort-board.vue")
  },
  {
    name: "base-system-tools-batch",
    path: "/base/system/tools/batch",
    meta: { ...(indexGBHeGeTCakJrkZZDBMzr16QceYYNvmFVAvSwK7yId60Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/system/tools/batch/index.vue")
  },
  {
    name: "biz-ksis-dev-unit-price",
    path: "/biz/ksis/dev/unit-price",
    meta: { ...(indexPkZyqFSyGAAac4Byz_iBXZgrzu_45CLkXAleH63FDgT0IMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/dev/unit-price/index.vue")
  },
  {
    name: "biz-ksis-longterm-sales",
    path: "/biz/ksis/longterm/sales",
    meta: { ...(indexfmLv8vqRTNMAL3cctmu63nxHK4cvHmmvgP0Kt3xMa4kMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/longterm/sales/index.vue")
  },
  {
    name: "biz-ksis-price-overseas",
    path: "/biz/ksis/price/overseas",
    meta: { ...(indexOjaST7dL9spZv7IrWoWZXC_tNibXJNZ8B4DtaAoReVYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/price/overseas/index.vue")
  },
  {
    name: "biz-ksis-price-sub-item",
    path: "/biz/ksis/price/sub-item",
    meta: { ...(indexRKTuw4yddSsWyz_k_aFHxmNruFVlXboRH2c24lXN1T4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/price/sub-item/index.vue")
  },
  {
    name: "biz-ksis-order-quote-doc",
    path: "/biz/ksis/order/quote-doc",
    meta: { ...(indexjIXzN76ZxApQJHZv4SCIlO_45q6kYPuwTB_45ZNHDR9kFrAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/order/quote-doc/index.vue")
  },
  {
    name: "biz-ksis-price-mold-cost",
    path: "/biz/ksis/price/mold-cost",
    meta: { ...(index1UoUacukDpWSRxGRSgFCi9r6sd2mWq62TvCKlRwzkZYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/price/mold-cost/index.vue")
  },
  {
    name: "base-guide-backend-api-executor",
    path: "/base/guide/backend/api-executor",
    meta: { ...(api_45executor989x2QMRVkQC17qj_i242VWpjYmT_45CpKDphW7qCojpAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/guide/backend/api-executor.vue")
  },
  {
    name: "base-guide-backend-paging-board",
    path: "/base/guide/backend/paging-board",
    meta: { ...(paging_45boardw0UDuPGvLqhs0taaQpRWScwlYndBG6anwiMd6K0WK8oMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/guide/backend/paging-board.vue")
  },
  {
    name: "base-guide-backend-scroll-board",
    path: "/base/guide/backend/scroll-board",
    meta: { ...(scroll_45boardgpEplvauv3iJXMN7gcxw7biSuS3tSIahrriojTAR_4550Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/guide/backend/scroll-board.vue")
  },
  {
    name: "base-system-settings-i18n",
    path: "/base/system/settings/i18n",
    meta: { ...(indexqbgYiy7iR8cwyL5hdvxoLmka_n3xAZoeCetuVEv4HEQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/system/settings/i18n/index.vue")
  },
  {
    name: "biz-ksis-dev-mold-process",
    path: "/biz/ksis/dev/mold-process",
    meta: { ...(indexPZ_45uOgDmYToL7maluZCfXnEgVaBzrW_45Ux2CB0lgLIzkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/dev/mold-process/index.vue")
  },
  {
    name: "biz-ksis-etc-tech-service",
    path: "/biz/ksis/etc/tech-service",
    meta: { ...(indexvoFd_45d0dWyiBNDHCP_NCVufBJCqRXielr4qnr364NDMMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/etc/tech-service/index.vue")
  },
  {
    name: "biz-ksis-order-order-info",
    path: "/biz/ksis/order/order-info",
    meta: { ...(indexXyvuFbScy7b_6jbixM2DToB9D_45es3jEJCFSHj2kOU64Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/order/order-info/index.vue")
  },
  {
    name: "base-guide-backend-biz-dev-guide",
    path: "/base/guide/backend/biz-dev-guide",
    meta: { ...(biz_45dev_45guideuOGfI4kgzjJOcBPNq95AxQQAnLgkwq2t9AEaBFoar_458Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/guide/backend/biz-dev-guide.vue")
  },
  {
    name: "base-system-settings-codes",
    path: "/base/system/settings/codes",
    meta: { ...(indexT4NGwpn25IwEDM2y9me8aWaR6itAIV9NfRmhcdoIo_45QMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/system/settings/codes/index.vue")
  },
  {
    name: "base-system-settings-menus",
    path: "/base/system/settings/menus",
    meta: { ...(index_Kn87_45zTz8V1MaRjxLLcdlUcdRz3E5itK5Db83tsF04Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/system/settings/menus/index.vue")
  },
  {
    name: "biz-ksis-baseinfo-customer",
    path: "/biz/ksis/baseinfo/customer",
    meta: { ...(indexoEY4MRAkW9SNRxCk_BJ9h6DDJsfVLkLFrS3f7HV_CDwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/baseinfo/customer/index.vue")
  },
  {
    name: "biz-ksis-order-quote-draft",
    path: "/biz/ksis/order/quote-draft",
    meta: { ...(indexGg6s3g3H3_45npG6W5uliPxTRo13QfIqFPcd1P_FDpTwYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/order/quote-draft/index.vue")
  },
  {
    name: "biz-ksis-price-design-cost",
    path: "/biz/ksis/price/design-cost",
    meta: { ...(indexCmvGxq7OwpbRrjB_3Fn733SFcZB1Pc9k8jVgVxK2Ou4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/price/design-cost/index.vue")
  },
  {
    name: "biz-ksis-price-negotiation",
    path: "/biz/ksis/price/negotiation",
    meta: { ...(indexbuvHT7ZWBaeeII82S6ZbwBrg6gUK8e4EDxKvTNoB6rYMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/price/negotiation/index.vue")
  },
  {
    name: "base-system-tools-generator",
    path: "/base/system/tools/generator",
    meta: { ...(indexif85_45L7eGxLvCVZC2i6YnMMXgDiCV_451yB_5I4zIk_45kgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/system/tools/generator/index.vue")
  },
  {
    name: "biz-ksis-approval-authority",
    path: "/biz/ksis/approval/authority",
    meta: { ...(indexOkiQE7tYRFWiIsFGuENCGldYnLVGWWRT3FcOVZqOanoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/approval/authority/index.vue")
  },
  {
    name: "biz-ksis-order-order-result",
    path: "/biz/ksis/order/order-result",
    meta: { ...(indexy5VvXRKNLKRS6ViYXChNXN2AZSNIZmO1T32OQI0N5_8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/order/order-result/index.vue")
  },
  {
    name: "biz-ksis-pdis-product-order",
    path: "/biz/ksis/pdis/product-order",
    meta: { ...(indexk4tgk9m14loTOytxl5spCXrKEksxe1wG11EYnBK3msEMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/pdis/product-order/index.vue")
  },
  {
    name: "biz-ksis-price-inspect-diff",
    path: "/biz/ksis/price/inspect-diff",
    meta: { ...(indexz5OXN6_LVYu0nNirhl1pCb9HoxUB1T5oeBlnqMRoLJUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/price/inspect-diff/index.vue")
  },
  {
    name: "base-guide-backend-infinite-scroll",
    path: "/base/guide/backend/infinite-scroll",
    meta: { ...(infinite_45scrollEmAoCwdGEI9VdORn7HUN_oJZaq7O6zyx19OrBB_45WamsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/guide/backend/infinite-scroll.vue")
  },
  {
    name: "base-guide-backend-sending-service",
    path: "/base/guide/backend/sending-service",
    meta: { ...(sending_45serviceZTnircmNTJkwdZkQUi5MjCzvjljjAs0IhFtoCyPu0ogMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/guide/backend/sending-service.vue")
  },
  {
    name: "base-system-dashboard-layout",
    path: "/base/system/dashboard/layout",
    meta: { ...(indexy5oNqBhlS0TZn4O9_VbbbMfxQZLpGynKlRL1BJRV_45_45YMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/system/dashboard/layout/index.vue")
  },
  {
    name: "biz-ksis-approval-delegation",
    path: "/biz/ksis/approval/delegation",
    meta: { ...(indextPeN2BFDUUv0KE7bFOKGcfmLZG4WsMRLcxSwWebkPFUMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/approval/delegation/index.vue")
  },
  {
    name: "biz-ksis-baseinfo-change-log",
    path: "/biz/ksis/baseinfo/change-log",
    meta: { ...(index88ZJz_phaJA82GCBNn7Dh6DlS6BG2IkRgK0_45VZPyj9sMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/baseinfo/change-log/index.vue")
  },
  {
    name: "biz-ksis-baseinfo-hmc-prefix",
    path: "/biz/ksis/baseinfo/hmc-prefix",
    meta: { ...(indexgmbGMdTKZqxy_45I5IvY7ufSHfWmk7c5eZGDGspZP9DPgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/baseinfo/hmc-prefix/index.vue")
  },
  {
    name: "biz-ksis-baseinfo-item-group",
    path: "/biz/ksis/baseinfo/item-group",
    meta: { ...(indexwYPLnoRwmmvX3GXlsg2slD0vDnYKKBTMwvcM95twpcsMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/baseinfo/item-group/index.vue")
  },
  {
    name: "biz-ksis-order-status-by-doc",
    path: "/biz/ksis/order/status-by-doc",
    meta: { ...(indexY4KgfPmgt2U8OE_WemRN_45NECKLHOYh9NiDsCovvp4ZwMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/order/status-by-doc/index.vue")
  },
  {
    name: "base-guide-backend-dashboard-widget",
    path: "/base/guide/backend/dashboard-widget",
    meta: { ...(dashboard_45widgetrBqnehBB5W_XOE5yBOzrcu0qvs2dUBpGbbmpCwi6PZkMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/guide/backend/dashboard-widget.vue")
  },
  {
    name: "biz-ksis-baseinfo-bid-project",
    path: "/biz/ksis/baseinfo/bid-project",
    meta: { ...(indexembP40VS22dsxUf_Z1NfXvMkRzWG2XXnpzhU7RC53FgMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/baseinfo/bid-project/index.vue")
  },
  {
    name: "base-system-dashboard-widget-manager",
    path: "/base/system/dashboard/widget-manager",
    meta: { ...(widget_45managerRUMfUb1C4i9nYk_VfJVSq_45_lFTKR35phpIeiveIBS1AMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/system/dashboard/widget-manager.vue")
  },
  {
    name: "biz-ksis-price-part-comparison",
    path: "/biz/ksis/price/part-comparison",
    meta: { ...(indexxeYtRJwdzFhbMS6PKZqXQjt7CPyw_45sKx4AocEWqIdmoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/price/part-comparison/index.vue")
  },
  {
    name: "biz-ksis-baseinfo-spec-category",
    path: "/biz/ksis/baseinfo/spec-category",
    meta: { ...(index3zVUMKY883tV5fsmVojrc_JN_i4WEfRa2y8EaVPoVfQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/baseinfo/spec-category/index.vue")
  },
  {
    name: "biz-ksis-price-agreed-reduction",
    path: "/biz/ksis/price/agreed-reduction",
    meta: { ...(index6FgeHQ9DUV4mfLeJAyHeDg2o6SoNPcfF6UjiJyEXGvQMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/price/agreed-reduction/index.vue")
  },
  {
    name: "biz-ksis-workbase-business-trip",
    path: "/biz/ksis/workbase/business-trip",
    meta: { ...(indexu2ZSDKtihEF_45K61Ce4BdrMuyIB0cvxRP3EpXSDoVoRoMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/workbase/business-trip/index.vue")
  },
  {
    name: "biz-ksis-order-status-by-project",
    path: "/biz/ksis/order/status-by-project",
    meta: { ...(indexh9D949mmfhFwcQngidDxzbv4daFyFgdTwtlDgJUUShcMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/order/status-by-project/index.vue")
  },
  {
    name: "base-system-auth-menu-permissions",
    path: "/base/system/auth/menu-permissions",
    meta: { ...(indexrCjY5VMub9k6pJD8r1Kivh3cF3X6Y3mHpdvYMANfoL8Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/base/system/auth/menu-permissions/index.vue")
  },
  {
    name: "biz-ksis-baseinfo-item-group-owner",
    path: "/biz/ksis/baseinfo/item-group-owner",
    meta: { ...(indexp3aGhpRZGcePQ9UmhXYhXvlgc5lrPvbs0OFgpTeGVugMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/baseinfo/item-group-owner/index.vue")
  },
  {
    name: "biz-ksis-price-overseas-status-all",
    path: "/biz/ksis/price/overseas-status-all",
    meta: { ...(indexd55aXi8bGNYcDns_b4c6MndZsKoW3gUc3xoqQTOA3DAMeta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/price/overseas-status-all/index.vue")
  },
  {
    name: "biz-ksis-baseinfo-customer-part-map",
    path: "/biz/ksis/baseinfo/customer-part-map",
    meta: { ...(indexhSDMzPLmwnAA5E5Z2MO7FS4kJBheKSWCoL3vFQmwLR4Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/baseinfo/customer-part-map/index.vue")
  },
  {
    name: "biz-ksis-workbase-official-document",
    path: "/biz/ksis/workbase/official-document",
    meta: { ...(indexSf0r_ASwCdl_45OYUkATPLs7h_45mRzmBhLsoThqXM9cDa0Meta || {}), ...{"middleware":"auth"} },
    component: () => import("/app/pages/biz/ksis/workbase/official-document/index.vue")
  }
]